import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Learn from "@/pages/Learn";

export const Route = createFileRoute("/_app/learn/")({
  component: () => (
    <PageGate pageKey="learn"><Learn /></PageGate>
  ),
});
